'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bemReactCore = require('bem-react-core');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACCOUNT = 'yandex_ru',
    PROP_TNS = 'tnsCounterTns_' + ACCOUNT,
    PROP_CALLBACK = 'tnscounter_callback';

exports.default = (0, _bemReactCore.declMod)({ type: 'js' }, {
    block: 'b-statcounter',
    elem: 'tns',
    didMount: function didMount() {
        this.__self.loadTns();
        this.addCounter(this.props);
    },
    addCounter: function addCounter(params) {
        var tnsCallbacks = window[PROP_CALLBACK] || (window[PROP_CALLBACK] = []),
            setCounter = function setCounter() {
            try {
                window[PROP_TNS] = new TNS.TnsCounter(_extends({ // eslint-disable-line
                    tmsec: params.id }, params));
            } catch (e) {}
        };

        window[PROP_TNS] ? setCounter() : tnsCallbacks.push(setCounter);
    },

    tag: 'i',
    // Атрибуты не нужны, т.к. вызываем счетчик через js
    attrs: null
}, {
    loadTns: function loadTns() {
        var haveTns = window.TNS && TNS.Counter; // eslint-disable-line no-undef

        if (!haveTns) {
            var script = document.createElement('script');

            script.src = '//www.tns-counter.ru/tcounter.js';
            script.async = true;

            document.body.appendChild(script);
        }

        this.loadTns = function () {};
    },

    propTypes: {
        account: _propTypes2.default.string
    },
    defaultProps: {
        account: ACCOUNT
    }
});